var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "mt-3 mb-3" },
    [
      _c("plain-text-control", {
        attrs: { title: _vm.title, required: _vm.required }
      }),
      _vm._v(" "),
      _c(
        "table",
        {
          staticClass: "table tablerow",
          attrs: { "aria-label": _vm.$t(_vm.title) }
        },
        [
          _c("thead", [
            _c("tr", [
              _c(
                "th",
                { staticClass: "w-15", attrs: { id: _vm.title + "_0" } },
                [_c("span", [_vm._v(_vm._s(_vm.$t(_vm.columns[0])))])]
              ),
              _vm._v(" "),
              _c(
                "th",
                { staticClass: "w-10", attrs: { id: _vm.title + "_1" } },
                [_c("span", [_vm._v(_vm._s(_vm.$t(_vm.columns[1])))])]
              ),
              _vm._v(" "),
              _c(
                "th",
                { staticClass: "w-30", attrs: { id: _vm.title + "_2" } },
                [_c("span", [_vm._v(_vm._s(_vm.$t(_vm.columns[2])))])]
              ),
              _vm._v(" "),
              _c(
                "th",
                { staticClass: "w-20", attrs: { id: _vm.title + "_3" } },
                [_c("span", [_vm._v(_vm._s(_vm.$t(_vm.columns[3])))])]
              )
            ])
          ]),
          _vm._v(" "),
          _c(
            "tbody",
            _vm._l(_vm.items, function(item, index) {
              return _c("tr", { key: index }, [
                _c(
                  "th",
                  { staticClass: "w-15 row-heading" },
                  [
                    _c("plain-text-control", {
                      attrs: { noMargin: true, title: item.name }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "td",
                  { staticClass: "input-cell" },
                  [
                    _c("decimal-input-control", {
                      attrs: {
                        name: "TotalArea" + index,
                        required: true,
                        disabled: _vm.$attrs.disabled || _vm.isReadOnly,
                        placeholderKey: "EnterValue",
                        minValue: _vm.getMin(item),
                        labelledBy: _vm.title + "_1"
                      },
                      model: {
                        value: item.totalArea,
                        callback: function($$v) {
                          _vm.$set(item, "totalArea", $$v)
                        },
                        expression: "item.totalArea"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "td",
                  { staticClass: "input-cell" },
                  [
                    _c("decimal-input-control", {
                      attrs: {
                        name: "STEAFundedArea" + index,
                        required: true,
                        disabled: _vm.$attrs.disabled || _vm.isReadOnly,
                        placeholderKey: "EnterValue",
                        maxValue: _vm.getMax(item),
                        labelledBy: _vm.title + "_2"
                      },
                      model: {
                        value: item.steaFundedArea,
                        callback: function($$v) {
                          _vm.$set(item, "steaFundedArea", $$v)
                        },
                        expression: "item.steaFundedArea"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("td", { staticClass: "disabled-background" }, [
                  _c("span", { staticClass: "right" }, [
                    _vm._v(_vm._s(_vm.rowTotal(item)))
                  ])
                ])
              ])
            }),
            0
          ),
          _vm._v(" "),
          _c("tfoot", [
            _c("tr", [
              _c("th", { staticClass: "w-15 disabled-background" }, [
                _c("span", [
                  _vm._v(_vm._s(_vm._f("toUpperCase")(_vm.$t("Total"))))
                ])
              ]),
              _vm._v(" "),
              _c("td", { staticClass: "disabled-background" }, [
                _c("span", { staticClass: "right" }, [
                  _vm._v(_vm._s(_vm._f("formatNumber")(_vm.totalTotalArea)))
                ])
              ]),
              _vm._v(" "),
              _c("td", { staticClass: "disabled-background" }, [
                _c("span", { staticClass: "right" }, [
                  _vm._v(
                    _vm._s(_vm._f("formatNumber")(_vm.totalSteaFundedArea))
                  )
                ])
              ]),
              _vm._v(" "),
              _c("td", { staticClass: "disabled-background" }, [
                _c("span", { staticClass: "right" }, [
                  _vm._v(
                    _vm._s(
                      _vm.rowTotal({
                        totalArea: _vm.totalTotalArea,
                        steaFundedArea: _vm.totalSteaFundedArea
                      })
                    )
                  )
                ])
              ])
            ])
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }